var module = angular.module('octopusApp.infrastructure');

module.filter('extension', function () {
  return function (input) {
    return input.split('.').pop().toLowerCase();
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/filters/extension.js
// module id = 1293181679942582
// module chunks = 1